export enum MembershipPlanFields {
  MembershipPlan = 'membershipPlanInfo',
}
